import {connect} from 'react-redux';

export function withLabels(Component) {
  return connect((state, passedProps) => {
    return ({
      labels: passedProps.labels || state.labels
    })
  })(Component);
}

export function withLogo(Component) {
  return connect((state, passedProps) => {
    return ({
      logoSrc: passedProps.logoSrc || state.logo
    })
  })(Component);
}